import { Component, OnInit, Input } from '@angular/core';
import { faDownload } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-icon-item',
  templateUrl: './icon-item.component.html',
  styleUrls: ['./icon-item.component.scss']
})
export class IconItemComponent implements OnInit {

  faDownload = faDownload;

  @Input() id: number;
  @Input() title: string;
  @Input() description: string;
  @Input() img: string;
  @Input() path: string;
  @Input() icon: string;
  constructor() { }

  ngOnInit() {
  }

}
